import type { setAuditingStepAction, AuditingStep } from './types';
import { AuditingStepEnum } from './types';

export function auditingStepReducer(
  state: AuditingStep,
  action: setAuditingStepAction
): AuditingStep {
  switch (action.type) {
    case AuditingStepEnum.setAuditingStep:
      return action.payload.step;
    default:
      return state;
  }
}
